/**
 *上传图片存储
 **/

const formData = {
  state: {
    parterId: '',
    idCardUrl: '', //法人身份证地址
    corporationName: '', //法人名称
    certId: '', //法人证件号
    certType: 0, //法人证件类型
    licenseUrl: '', //营业执照图片地址
    enterpriseName: '', //公司名称
    taxPayerNo: '', //统一信用代码
    employeeNumber: '', //公司人数
    sellSum: '', //年销售额
    totalAssets: '', //资产总额
    stockHolderName: '', //股东姓名
    stockHolderCertod: '', //股东证件号
    stockHolderCerttype: 0, //法人证件类型
    stockHolderRegDate: '', // 股东证件登记日期
    stockHolderIdExpiry: '', // 股东证件失效日期
    stockHolderIdRegCityName: '', // 地址名称
    stockHolderIdRegCity: '' // 地址
  },
  mutations: {
    //设置身份证照片
    idCardZ: (state, obj) => {
      state.idCardUrl = obj.localUrl
      state.corporationName = obj.name
      state.name = obj.number
    },
    //设置营业执照照片
    setLicenseUrl: (state, obj) => {
      state.licenseUrl = obj.localUrl
    },
    //基本信息存储
    setInfo: (state, obj) => {
      state.corporationName = obj.corporationName //法人名称
      state.certId = obj.certId //法人证件号
      state.enterpriseName = obj.enterpriseName //公司名称
      state.taxPayerNo = obj.taxPayerNo //统一信用代码
      state.employeeNumber = obj.employeeNumber //公司人数
      state.sellSum = obj.sellSum //年销售额
      state.totalAssets = obj.totalAssets //资产总额
    },
    //基本信息存储
    setShareholder: (state, obj) => {
      state.stockHolderName = obj.stockHolderName //股东姓名
      state.stockHolderCertod = obj.stockHolderCertod //股东证件号
      state.stockHolderRegDate = obj.stockHolderRegDate //股东证件登记日期
      state.stockHolderIdExpiry = obj.stockHolderIdExpiry //股东证件失效日期
      state.stockHolderIdRegCityName = obj.stockHolderIdRegCityName //地址名称
      state.stockHolderIdRegCity = obj.stockHolderIdRegCity //地址
    },
    setParterId: (state, obj) => {
      state.parterId = obj.parterId
    }

  },
  getters: {
    imgObj(state) {
      return state.imgObj
    }
  }
}

export default formData